import { createIcon } from '../icon'
import UnderwearMenIcon from '../svg/UnderwearMenIcon'

export const UnderwearMenIconDefault = createIcon(UnderwearMenIcon)
